import React, { useEffect, useState } from "react";
import axios from "axios";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { MdKeyboardDoubleArrowLeft, MdKeyboardDoubleArrowRight } from "react-icons/md";
import { toast } from "react-toastify";

import Response_Processing from "../../layout/Others/Response_Processing";
import NoRecordTable from "../../components/CommonComponents/NoRecordTable";
import AdminNavbar from "../../components/CommonComponents/AdminNavbar";
import AdminDeleteModal from "../../components/CommonComponents/AdminDeleteModal";
import Defaultloadinggif from "../../layout/Others/Defaultloadinggif";
import MessageBox from "../../components/CommonComponents/MessageBox";
import { ActionFormatterComponent } from "../../components/CommonMethod/CommonBoostrapFormatter";
import { getItemToken } from "../../Utils/localStorageUtils";
import { RxReload } from "react-icons/rx";
import ExportIcon from "../../components/Images/icons/Export_Icon_01.png";
import { IoClose } from "react-icons/io5";
import { donwloadCSV, downloadPDF, downloadXLSX } from "../../components/CommonMethod/CommonMethods";

const OrientationList = () => {
  const baseURL = process.env.REACT_APP_Baseurl;
  const headers = getItemToken("access_token");

  // Orientation endpoints and config (replace with real ones later)
  const orientationDefaultURL = {
    listApi: `${baseURL}/admin/orientation/index`,
    fetchArrayName: "data",
    MultiDeleteApi: `${baseURL}/admin/orientation/multi-delete`,
    reqBodyName: { deleteName: "ids" },
    addRouteLink: "/add-orientation",
    editRouteLink: "/edit-orientation/",
  };

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showOverlay, setShowOverlay] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [modelClose, setModelClose] = useState(false);
  const [itemToDelete, setItemToDelete] = useState([]);
  const [filter, setFilter] = useState("");
  const [reloading, setReloading] = useState(false);

  const fetchData = async (type) => {
    setLoading(true);
    try {
      const response = await axios.get(`${orientationDefaultURL.listApi}`, { headers });
      const result = response?.data?.[orientationDefaultURL.fetchArrayName] || [];

      // Export helpers
      if (type === "CSV") {
        await donwloadCSV(result, "ORIENTATION-LIST");
      }
      if (type === "PDF") {
        await downloadPDF(result, "ORIENTATION-LIST", ["INDEX", "NAME", "SLUG", "IMAGE DIMENSIONS", "IMAGE RATIO", "ACTIVE"]);
      }
      if (type === "XLSX") {
        await downloadXLSX(result, "ORIENTATION-LIST", ["INDEX", "NAME", "SLUG", "IMAGE DIMENSIONS", "IMAGE RATIO", "ACTIVE"]);
      }

      setApiData(result);
      setFilteredData(result);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to fetch orientations");
    } finally {
      setLoading(false);
      setShowOverlay(false);
    }
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
      formatter: (cell) => <MessageBox text={cell} />,
    },
    {
      dataField: "slug",
      text: "Slug",
      formatter: (cell) => <MessageBox text={cell} />,
    },
    {
      dataField: "images_size",
      text: "Image Dimensions",
      formatter: (cell) => <MessageBox text={String(cell)} />,
      headerStyle: { width: "160px" },
    },
    {
      dataField: "image_ratio",
      text: "Image Ratio",
      formatter: (cell) => <MessageBox text={String(cell || '')} />,
      headerStyle: { width: "120px" },
    },
    {
      dataField: "ACTIONS",
      text: "Actions",
      formatter: (cell, row) => (
        <ActionFormatterComponent cell={cell} row={row} link={orientationDefaultURL.editRouteLink} action={singleDelete} />
      ),
      headerStyle: { width: "180px" },
    },
  ];

  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="btn-group" role="group">
      <select
        className="form-select custom-page-select"
        value={currSizePerPage}
        onChange={(e) => onSizePerPageChange(e.target.value)}
      >
        {options.map((opt) => (
          <option key={opt.page} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
    </div>
  );

  const options = {
    sizePerPageRenderer,
    paginationSize: 4,
    sizePerPage: 10,
    nextPageText: "Next",
    prePageText: "Prev",
    firstPageText: (
      <span>
        <MdKeyboardDoubleArrowLeft />
      </span>
    ),
    lastPageText: (
      <span>
        <MdKeyboardDoubleArrowRight />
      </span>
    ),
    showTotal: true,
    alwaysShowAllBtns: true,
  };

  const selectRow = {
    mode: "checkbox",
    onSelect: (row, isSelect) => {
      if (!row) return;
      if (isSelect) setItemToDelete([...itemToDelete, row.id]);
      else setItemToDelete(itemToDelete?.filter((id) => id !== row?.id));
    },
    style: { width: "50px" },
    selected: itemToDelete,
    selectionHeaderRenderer: ({ checked }) => (
      <div>
        <input type="checkbox" checked={checked} onChange={handleAll} />
      </div>
    ),
  };

  const closeModal = () => {
    setModelClose(false);
    setItemToDelete([]);
  };

  const openModal = () => setModelClose(true);

  const singleDelete = (id) => {
    setModelClose(true);
    setItemToDelete([id]);
  };

  const handleDeletedata = () => {
    handleConfirmDelete();
    closeModal();
  };

  const handleConfirmDelete = async () => {
    setShowOverlay(true);
    try {
      const response = await axios.delete(`${orientationDefaultURL.MultiDeleteApi}`, {
        headers,
        data: { [orientationDefaultURL.reqBodyName.deleteName]: [...itemToDelete] },
      });
      const result = response?.data;
      if (result?.status) {
        toast.success(result?.message || "Deleted successfully");
        setItemToDelete([]);
        await fetchData();
      } else {
        toast.error(result?.message || "Delete failed");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Delete request failed");
    } finally {
      setShowOverlay(false);
    }
  };

  const handleAll = () => {
    const newValue = !selectAll;
    setSelectAll(newValue);
    setItemToDelete(newValue ? filteredData?.map((item) => item?.id) : []);
  };

  const handleFilter = (event) => {
    const searchTerm = event.target.value.toLowerCase();
    setFilter(searchTerm);
    if (searchTerm.trim() === "") {
      setFilteredData(apiData);
      return;
    }
    const filteredResults = apiData.filter((item) =>
      ["id", "name", "slug", "images_size", "image_ratio"].some((property) =>
        (typeof item[property] === "string" && item[property].toLowerCase().includes(searchTerm)) ||
        (typeof item[property] === "number" && item[property].toString().includes(searchTerm))
      ) || (typeof item.id === "number" && item.id.toString().includes(searchTerm))
    );
    setFilteredData(filteredResults);
  };

  const handleClear = () => {
    setFilter("");
    setFilteredData(apiData);
  };

  const reloadAction = async () => {
    setReloading(true);
    await new Promise((resolve) => setTimeout(resolve, 800));
    try {
      const response = await axios.get(`${orientationDefaultURL.listApi}`, { headers });
      const result = response?.data?.[orientationDefaultURL.fetchArrayName] || [];
      setApiData(result);
      setFilteredData(result);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Refresh failed");
    } finally {
      setReloading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (showOverlay) return <Defaultloadinggif className="heightOnLoader" />;

  return (
    <>
      {showOverlay && <Response_Processing />}
      {modelClose && (
        <AdminDeleteModal
          modelClose={modelClose}
          deleteClose={closeModal}
          deleteAction={handleDeletedata}
          buttonText={itemToDelete?.length}
        />
      )}

      <AdminNavbar
        heading={"All Orientation"}
        totalDataLength={apiData?.length}
        deleteCount={itemToDelete?.length}
        navigation={orientationDefaultURL.addRouteLink}
        deleteMethod={openModal}
        navText={"Add Orientation"}
      />

      <div className="theme-bg-color p-3 rounded-2 bootstrapTable multi-delete-width">
        <div className="d-flex align-items-center flex-wrap justify-content-between mb-3">
          <div className="filterContainer">
            <input
              type="text"
              id="filter-search"
              placeholder="Search the list "
              className="filter form-control theme-text-color theme-border-secondary  theme-bg-color-secondary"
              value={filter}
              onChange={handleFilter}
            />
            {filter?.length > 0 && (
              <button type="button" className="clearBtn" onClick={handleClear}>
                <IoClose className="custom-close-btn" />
              </button>
            )}
          </div>
          <div className="d-flex align-items-center">
            <button
              id="reloadButton"
              className={`bg-transparent  custom-tool-tip-parent reloadButton theme-text-color p-2 me-2  border border-2 rounded-circle theme-border-color `}
              onClick={reloadAction}
            >
              <RxReload style={{ width: "18px", height: "15px" }} className={`${reloading ? "rotate-load" : ""}`} />
            </button>

            <div className="dropdown d-block ms-2 " key={"2"}>
              <button className="btn btn-success dropdown-toggle d-flex hideArrow" type="button" id="exportAllButton" data-bs-toggle="dropdown" aria-expanded="false">
                <span className="fw-bolder text-white">Export All</span>
                <img src={ExportIcon} className="ms-2 exportIcon" alt="exportIcon" />
              </button>
              <ul className="dropdown-menu theme-bg-color" aria-labelledby="exportAllButton">
                <li id="exportallCSV" className="dropdown-item theme-text-color" onClick={() => fetchData("CSV", "ALL")}>
                  CSV
                </li>
                <li id="exportallPDF" className="dropdown-item theme-text-color" onClick={() => fetchData("PDF", "ALL")}>
                  PDF
                </li>
                <li id="exportallXLSX" className="dropdown-item theme-text-color" onClick={() => fetchData("XLSX", "ALL")}>
                  XLSX
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          {reloading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(255,255,255,0.6)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
              }}
            >
              <Defaultloadinggif />
            </div>
          )}
          <BootstrapTable
            keyField="id"
            id="All-orientation"
            data={filteredData}
            columns={columns}
            pagination={paginationFactory(options)}
            className="no-border-table theme-text-color"
            noDataIndication={<NoRecordTable result={filteredData?.length} loader={loading} />}
            hover
            headerClasses="videoWidth"
            selectRow={selectRow}
            selectAll={selectAll}
          />
        </div>
      </div>
    </>
  );
};

export default OrientationList;

